import moment from "moment/min/moment-with-locales";
import Button from "react-bootstrap/Button";
import { Col, FormControl, FormGroup, FormLabel, Modal, Stack } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useRevalidator } from "react-router-dom";
import { createBit, createBitInNewCollection } from "./clocksFunctions";
import CollectionsPicker from "../Pickers/CollectionsPicker";

export default function CreateBitModal({ onClose, show, radioId, newBit }) {
    const revalidator = useRevalidator();

    const [formData, setFormData] = useState({ collection: [], bitName: "" });
    const [creating, setCreating] = useState(false);

    useEffect(() => {
        if (!show) {
            setFormData({ collection: [], bitName: "" });
        }
    }, [show]);

    async function handleConfirm() {
        if (!formData.collection.length) return;
        setCreating(true);
        if (formData.collection[0].collection_id) {
            await createBit(formData.collection[0].collection_id, formData.bitName || newBit.placeholder, newBit.bitStart, newBit.bitEnd);
        } else {
            await createBitInNewCollection(
                radioId,
                formData.collection[0].collection_name,
                formData.bitName || newBit.placeholder,
                newBit.bitStart,
                newBit.bitEnd
            );
        }
        setFormData({ collection: [], bitName: "" });
        onClose();
        revalidator.revalidate();
        setCreating(false);
    }

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton closeVariant={"white"}>
                <Modal.Title>Add bit to collection</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <CollectionsPicker
                    formData={formData}
                    setFormData={setFormData}
                    name={"clocks-add-bit"}
                    colXl={12}
                    filterFunction={x => x.radio_id === radioId}
                    allowNew={true}
                    includeRadioName={false}
                />
                <FormGroup as={Col} className="my-3" controlId="newBitName">
                    <FormLabel>Bit Name</FormLabel>
                    <FormControl
                        type="text"
                        value={formData.bitName}
                        onChange={e => setFormData({ ...formData, bitName: e.currentTarget.value })}
                        placeholder={newBit.placeholder ?? `${moment(newBit.bitStart).format("L LTS")} - ${moment(newBit.bitEnd).format("L LTS")}`}
                    />
                </FormGroup>
                <FormGroup as={Col} className="col-12" controlId="newBitRange">
                    <FormLabel>Bit Range</FormLabel>
                    <Stack direction="horizontal" gap={2}>
                        <span className="fw-bold">{moment(newBit.bitStart).format("L LTS")}</span>
                        <span>-</span>
                        <span className="fw-bold">{moment(newBit.bitEnd).format("L LTS")}</span>
                    </Stack>
                </FormGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="ra-yellow" onClick={handleConfirm} disabled={creating || !formData.collection.length}>
                    Add
                </Button>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
